export const COLLECTION_NAMES = {
  USERS: 'users',
  BOTS: 'bots',
  NODES: 'nodes',
  ROLES: 'roles',
  CORPS: 'corps',
  ENVIRONMENTS: 'environments',
  NOTIFICATIONS: 'notifications',
  PERMISSIONS: 'permissions',
  SEQUENCES: 'sequences',
  HIERARCHY_ELEMENTS: 'hierarchy_elements',
};
